export default {
  en: {
    OrderIndex: {
      title: 'Orders',
    },
  },
};
